import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Contract } from 'src/app/models/entities/contract';
import { ContractType } from 'src/app/models/entities/contract-type';
import { Dealer } from 'src/app/models/entities/dealer';
import { Portal } from 'src/app/models/entities/portal';
import { VLogoCustomer } from 'src/app/models/entities/v-logo-customer';
import { VLogoProject } from 'src/app/models/entities/v-logo-project';
import { VLogoService } from 'src/app/models/entities/v-logo-service';
import { ContractTypeService } from 'src/app/services/contract-type.service';
import { ContractService } from 'src/app/services/contract.service';
import { DealerService } from 'src/app/services/dealer.service';
import { LogoService } from 'src/app/services/logo.service';
import { NbsUserService } from 'src/app/services/nbs-user.service';
import { PortalService } from 'src/app/services/portal.service';

@Component({
  selector: 'app-contract-add',
  templateUrl: './contract-add.component.html',
  styleUrls: ['./contract-add.component.css']
})
export class ContractAddComponent implements OnInit {

  destroy$ = new Subject<void>();
  form: FormGroup;
  contractTypes$: Observable<ContractType[]>;
  customers$: Observable<VLogoCustomer[]>;
  services$: Observable<VLogoService[]>;
  projects$: Observable<VLogoProject[]>;
  portals$: Observable<Portal[]>;
  currencyUnits: any[];
  contractNumber: string;
  dealers$: Observable<VLogoCustomer[]>;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastrService: ToastrService,
    private contractService: ContractService,
    private contractTypeService: ContractTypeService,
    private portalService: PortalService,
    private logoService: LogoService,
    private userService: NbsUserService,
    private dealerService: DealerService
  ) {
    this.currencyUnits = [{ name: "TL" }, { name: "USD" }, { name: "EUR" }]
  }


  ngOnInit(): void {
    this.createForm();
    this.loadDatas();
  }

  createForm() {
    this.form = this.formBuilder.group({
      id: 0,
      contractNumber: [""],
      customerCode: [""],
      portalId: [0],
      contractTypeId: ["", Validators.required],
      serviceCode: [""],
      projectCode: [""],
      serviceUnitPrice: ["", Validators.required],
      startDate: ["", Validators.required],
      endDate: ["", Validators.required],
      invoiceDate: ["", Validators.required],
      notes: [""],
      currencyUnit: ["TL", Validators.required],
      organizationName: [""],
      reportTag1: [""],
      reportTag2: [""],
      reportTag3: [""],
      customerId: ["", Validators.required],
      serviceId: ["", Validators.required],
      projectId: [0],
      dealerId: [0],
      commissionPrice: [0],
      isActive: true
    })
  }


  loadDatas() {
    this.contractTypes$ = this.contractTypeService.getList().pipe(map(result => result.data));
    this.customers$ = this.logoService.getCustomers().pipe(map(result => result.data));
    this.dealers$ = this.logoService.getCustomers().pipe(map(result => result.data.filter(a => a.specodE4 == 'B.01')));
    this.services$ = this.logoService.getServices().pipe(map(result => result.data));
    this.portals$ = this.portalService.getList().pipe(map(result => result.data));
    this.projects$ = this.logoService.getProjects().pipe(map(result => result.data));
    this.contractService.getLastRecordId().pipe(takeUntil(this.destroy$)).subscribe(result => {
      this.contractNumber = "ABN." + (result.data + 1).toString();
    })
  }


  add() {
    if (this.form.valid) {
      let contract: Contract = this.form.getRawValue();
      contract.portalId = (contract.portalId === null || contract.portalId === undefined) ? 0 : contract.portalId;
      contract.projectId = (contract.projectId === null || contract.projectId === undefined) ? 0 : contract.projectId;
      contract.dealerId = (contract.dealerId === null || contract.dealerId === undefined) ? 0 : contract.dealerId;
      contract.userId = this.userService.getUserId();
      this.logoService.getCustomerCodeById(contract.customerId).pipe(takeUntil(this.destroy$)).subscribe(cus => {
        contract.customerCode = cus.data[0].code;
        this.logoService.getServiceCodeById(contract.serviceId).pipe(takeUntil(this.destroy$)).subscribe(ser => {
          contract.serviceCode = ser.data[0].code;
          this.logoService.getProjectCodeById(contract.projectId).pipe(takeUntil(this.destroy$)).subscribe(pro => {
            if (pro.data.length > 0) contract.projectCode = pro.data[0].code; else contract.projectCode = "";
            this.contractService.add(contract).pipe(takeUntil(this.destroy$)).subscribe(
              data => {
                this.toastrService.success(data.message, "Başarılı");
                this.router.navigateByUrl('/contract');
              },
              er => {
                this.toastrService.error(er.error.message, "Hata!");
              }
            );
          })
        })
      })
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

}
